import { MyStore, reducers } from 'kts-platform-frame/redux';
import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import IOptions from './IOptions';
import { serverDomain } from 'kts-platform-frame/entry/configUtils';
import superagent from 'superagent';
import { Urls } from 'kts-platform-frame/entry/constant';
/**
 * 获取嵌入App的Token
 */
class GetAppToken extends ApiBasic<IOptions, IAppInfo> {

    /** 入口 */
    public async api(option: IOptions): Promise<Response<IAppInfo>> {
        const req: Request = new Request(CallType.GET, Urls.getAppToken, option);
        let data: Response<any> = await this.callAjax(req);
        return data;
        /* const code = option.code;
        const res = await superagent.get(serverDomain()+ Urls.getAppToken + '?code='+code) as any;
        if(res.body && res.body.body && res.body.ok) {
            return new Response(null, res.body.body);
        }else {
            return new Response(res.body.status, res.body);
        } */
    }
}

export default new GetAppToken().run;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/appStore/getAppToken/index.ts